// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-home-home-projects----home-projects-module---wrapper---19YnU","container":"src-components-home-home-projects----home-projects-module---container---2ZL8S","projects":"src-components-home-home-projects----home-projects-module---projects---HyUeD","first":"src-components-home-home-projects----home-projects-module---first---3I9Y-","viewAll":"src-components-home-home-projects----home-projects-module---viewAll---2jycC","col":"src-components-home-home-projects----home-projects-module---col---3kfEb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/home-projects/home-projects.module.css
// module id = 494
// module chunks = 35783957827783